<template>
  <div>
    <div class="jumbotron">

      <div class="btn-group pull-right" role="group" aria-label="">
        <button type="button" class="btn btn-sm btn-info" @click="btnNewEntryPoint">
        <i class="fas fa-plus-circle" aria-hidden="true"></i> New</button>
        <!-- FIXME -->
        <!-- <button type="button" class="btn btn-sm btn-warning" @click="btnUndo" v-if="undoKey && undoValue">
        <i class="fa fa-undo" aria-hidden="true"></i> Undo</button> -->
      </div>

      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item"><a href="#/apps">Apps</a></li>
        <li class="breadcrumb-item active">Config {{ app.name }}</li>
      </ol>

      <div class="row">
        <div class="col-md-6">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Update timeout value</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-edit card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-inverse card-danger text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Remove timeout value</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-minus-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#timeouts">Timeouts</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#schema-access">Schema Access</a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade active show" id="timeouts">
        <!-- <div class="form-inline float-right btn-group">
          <button type="button" class="btn btn-sm btn-info" @click="btnNewEntryPoint">
          <i class="fa fa-plus" aria-hidden="true"></i> New</button>
          <button type="button" class="btn btn-sm btn-warning" @click="btnUndo" v-if="undoKey && undoValue">
          <i class="fa fa-undo" aria-hidden="true"></i> Undo</button>
        </div> -->
        <div v-if="config">
          <modal
            title="Create new entry point"
            :show.sync="modalShow"
            :backdrop="modalBackdrop"
            effect="zoom"
            width="400">
            <div slot="modal-header" class="modal-header">
              <h4 class="modal-title">
                <i class="fas fa-edit" aria-hidden="true"></i> Set Entry point
              </h4>
            </div>
            <div slot="modal-body" class="modal-body">
              <form>
                <div class="form-group row">
                  <label for="selectType" class="col-4 col-form-label">Entry Point Type</label>
                  <div class="col-8">
                    <select class="form-control" id="selectType" v-model="entryPointType">
                      <option>Helium View In WebApp</option>
                      <option>Scheduled Function</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label">Entry Point Scope</label>
                  <div class="col-8">
                    <input class="form-control"
                      type="text"
                      v-model="entryPointScope"
                      v-bind:readonly="entryPointScopeReadOnly"
                      v-bind:placeholder="entryPointScopePlaceholder"
                      required>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label">Entry Point</label>
                  <div class="col-8">
                    <input class="form-control"
                      type="text"
                      v-model="entryPointName"
                      v-bind:placeholder="entryPointNamePlaceholder"
                      required >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label">Timeout Value (Minutes)</label>
                  <div class="col-8">
                    <select class="form-control" :class="timeoutValueClass" v-model="entryPointValue">
                      <option v-for="i in timeoutValues">
                      {{ i }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div slot="modal-footer" class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="modalCloseCallback">Close</button>
              <button type="button" class="btn btn-primary" v-on:click="modalSaveCallback">Save</button>
            </div>
          </modal>

          <div v-if="loading" class="d-flex justify-content-center">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
          <div v-else>

            <form>
              <fieldset>
                <div class="form-group" v-if="config">
                  <div class="input-group">
                    <label class="col-6 col-form-label">
                      <i class="fas fa-check-circle" aria-hidden="true"></i> App is currently:
                    </label>
                    <select v-model="disabledApp" class="custom-select form-control">
                      <option disabled value="">Enable or disable this Helium app</option>
                      <option>
                        Enabled
                      </option>
                      <option>
                        Disabled
                      </option>
                    </select>
                    <button type="button" class="btn btn-sm btn-secondary" @click="btnApplyEnabled" >
                    <i class="fas fa-edit"></i> Apply</button>
                  </div>
                  <small class="form-text text-muted">A disabled App will not allow users to login and will not run any scheduled functions tasks to be processed</small>
                  <div class="input-group">
                    <label class="col-6 col-form-label">
                      <i class="fas fa-lock-open" aria-hidden="true"></i> App is currently:
                    </label>
                    <select v-model="lockedApp" class="custom-select form-control">
                      <option disabled value="">Lock or unlock this Helium app</option>
                      <option>
                        Locked
                      </option>
                      <option>
                        Unlocked
                      </option>
                    </select>
                    <button type="button" class="btn btn-sm btn-secondary" @click="btnApplyLocked">
                    <i class="fas fa-edit"></i> Apply</button>
                  </div>
                  <small class="form-text text-muted">A locked App will not allow users to login but background process will continue to run</small>
                  <div class="input-group">
                    <label class="col-6 col-form-label">
                      <i class="fa fa-database" aria-hidden="true"></i> Max Database Results
                    </label>
                    <select class="form-control" :class="maxDatabaseResultsValueClass" v-model="maxDatabaseResults">
                      <option v-for="i in maxDatabaseResultsValues">
                      {{ i }}
                      </option>
                    </select>
                    <button type="button" class="btn btn-sm btn-info" @click="btnApplyMaxDatabaseResults">
                    <i class="fas fa-edit"></i> Apply</button>
                  </div>
                  <small class="form-text text-muted">Maximum number of results that can be returned by Helium's <code>sql:query</code> feature. See <a href="https://wiki.mezzanineware.com/display/HTUT/Lesson+22%3A+Executing+SQL+Select+Queries+From+the+DSL">Lesson 22 (Executing SQL Select Queries From the DSL)</a> for more information.</small>
                </div>
              </fieldset>
            </form>
            <app-config-entry-point v-bind:config="config"></app-config-entry-point>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="schema-access">
        <div class="row">
          <div class="col">
            <div id="timeouts-info" class="alert alert-info" role="alert">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <strong>Schema Access</strong><br>
              <p>Alter DB obects (tables, views, functions, sequences) in the App Schema to owned by Helium and accessable by developers postgres accounts</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <blockquote class="blockquote">
              <form>
                <fieldset>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">App</label>
                      <input class="form-control" type="text" v-model="app.name" disabled readonly>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Team</label>
                      <select v-model="teamUser" id="selectTeamName"
                              class="custom-select form-control">
                          <option v-for="entry in teamNames">
                              {{ entry }}
                          </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <div class="btn-group pull-right">
                        <button type="button"
                          class="btn btn-primary btn-md"
                          data-toggle="tooltip"
                          v-on:click="grantAccess">
                          <i class="fa fa-upload" aria-hidden="true"></i>
                          Grant Access
                        </button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppConfigEntryPoint from '@/components/AppConfigEntryPoint.vue'
  import Feedback from '@/components/Feedback.vue'
  import { modal } from 'vue-strap'
  export default {
    name: 'Config',
    components: {
      AppConfigEntryPoint,
      Feedback,
      modal
    },
    data () {
      return {
        config: null,
        app: null,
        entryPointType: null,
        entryPointScope: null,
        entryPointName: null,
        entryPointValue: null,
        entryPointScopeTmp: null,
        entryPointNameTmp: null,
        entryPointValueTmp: null,
        entryPointScopeReadOnly: false,
        entryPointScopePlaceholder: null,
        entryPointNamePlaceholder: null,
        entryPointIsNew: false,
        modalShow: false,
        modalBackdrop: false,
        loading: true,
        teamNames: [],
        teamUser: '',
        endpointUndo: null,
        configUndo: null,
        undoKey: null,
        undoValue: null,
        maxDatabaseResults: null,
        disabledApp: null,
        lockedApp: null
      }
    },
    methods: {
      getCurrentConfig: function () {
        let vm = this
        let config = {}
        vm.config = null
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/get-config/'
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.config = response.data
            vm.feedbackSuccess = true
            vm.loading = false
            vm.$parent.loading = false
            vm.maxDatabaseResults = vm.config.maxDatabaseResults
            vm.disabledApp = vm.convertBooleanToFieldDisabled(vm.config.disabled)
            vm.lockedApp = vm.convertBooleanToFieldLocked(vm.config.locked)
          })
          .catch(function (response) {
            vm.$Simplert.open({ title: 'Error', message: 'Unable to get app config!', type: 'error' })
            vm.$parent.loading = false
          })
      },
      modalCloseCallback: function () {
        this.modalShow = false
      },
      modalSaveCallback: function () {
        this.modalShow = false
        this.postEntryPoint()
        this.clearModal()
      },
      postEntryPoint: function () {
        let vm = this

        if (vm.entryPointScope === null) {
          vm.$Simplert.open({ title: 'Validation', message: 'Please enter Entry Point Scope Name', type: 'error' })
          return
        } else if (vm.entryPointName === null) {
          vm.$Simplert.open({ title: 'Validation', message: 'Please enter Entry Point', type: 'error' })
          return
        } else if (!Number.isInteger(parseInt(vm.entryPointValue)) || vm.entryPointValue <= 0) {
          vm.$Simplert.open({ title: 'Validation', message: 'Please select a timeout value', type: 'error' })
          return
        }

        let entryPointScope = vm.entryPointScope
        let entryPointName = vm.entryPointName
        let entryPointValue = vm.entryPointValue

        if (!vm.entryPointIsNew) {
          let config = {}
          config['baseUrl'] = vm.$parent.environment.baseUrl
          config['appId'] = vm.app.id
          config['entryPoint'] = vm.entryPointTmp
          config['username'] = vm.$parent.username
          config['duration'] = 0
          let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/remove-entry-point'
          vm.$parent.loading = true
          vm.axios.post(endpoint, config).then(function (response) {
            vm.entryPointScope = entryPointScope
            vm.entryPointName = entryPointName
            vm.entryPointValue = entryPointValue
            vm.addEntryPoint(vm)
          }).catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
            vm.getCurrentConfig()
          })
        } else {
          vm.addEntryPoint(vm)
        }
      },
      addEntryPoint: function (vm) {
        let entryPoint = vm.entryPointScope + ':' + vm.entryPointName

        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/add-entry-point'
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['entryPoint'] = entryPoint.trim()
        config['duration'] = vm.entryPointValue
        config['username'] = vm.$parent.username
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
        .then(function (response) {
          vm.$parent.loading = false
          vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' })
          vm.getCurrentConfig()
        })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
            vm.getCurrentConfig()
          })
      },

      deleteEntryPoint: function (key, value) {
        let vm = this
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['entryPoint'] = key
        config['username'] = vm.$parent.username
        config['duration'] = 0

        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/remove-entry-point'
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' })
            vm.getCurrentConfig()
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
            vm.getCurrentConfig()
          })
      },

      updateEntryPoint: function (key, value, show) {
        var arr = key.split(':')
        var entryPointType
        if (arr[0] === 'processViewResponse') {
          entryPointType = 'Helium View In WebApp'
        } else {
          entryPointType = 'Scheduled Function'
        }
        this.entryPointTmp = key
        this.updateModalValues(entryPointType, arr[0], arr[1], value)
        if (!show) {
          this.undoKey = key
          this.undoValue = value
        }
        this.modalShow = show
      },
      clearModal: function () {
        this.entryPointType = null
        this.entryPointScope = null
        this.entryPointName = null
        this.entryPointValue = null
        this.entryPointIsNew = false
      },
      btnNewEntryPoint: function () {
        this.clearModal()
        this.modalShow = true
        this.entryPointIsNew = true
      },
      updateModalValues: function (type, scope, entryPoint, value) {
        this.entryPointType = type
        if (type === 'Helium View In WebApp') {
          this.entryPointScopeReadOnly = true
          this.entryPointScopePlaceholder = null
          this.entryPointNamePlaceholder = 'VXML filename (Without extension)'
          this.entryPointValue = value
          this.entryPointScope = 'processViewResponse'
          this.entryPointName = entryPoint
        } else if (type === 'Scheduled Function') {
          this.entryPointScope = null
          this.entryPointScopeReadOnly = false
          this.entryPointValue = value
          this.entryPointScopePlaceholder = 'DSL Unit name (As in .mez file)'
          this.entryPointNamePlaceholder = 'DSL function name (As in .mez file)'
          if (scope) {
            this.entryPointScope = scope
          } else {
            this.entryPointScope = null
          }
          this.entryPointName = entryPoint
        }
      },
      getTeams: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/team-names'
        vm.$parent.loading = true
        vm.axios.post(endpoint)
          .then(function (response) {
            vm.$parent.loading = false
            vm.teamNames = response.data
          })
          .catch(function (error) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' })
          })
      },
      grantAccess: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/migrate-app'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['teamUser'] = vm.teamUser
        config['appId'] = vm.app.id
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' })
          })
          .catch(function (error) {
            console.log(error.response)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' })
          })
      },
      btnUndo: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/add-entry-point'
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['entryPoint'] = vm.undoKey
        config['duration'] = vm.undoValue
        config['username'] = vm.$parent.username
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: 'Undo Done', type: 'success' })
            vm.getCurrentConfig()
            vm.undoKey = null
            vm.undoValue = null
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' })
            vm.getCurrentConfig()
          })
      },
      btnApplyMaxDatabaseResults: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/set-max-db-results'
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['maxDatabaseResults'] = vm.maxDatabaseResults
        config['username'] = vm.$parent.username
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' })
            vm.getCurrentConfig()
            vm.undoKey = null
            vm.undoValue = null
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' })
            vm.getCurrentConfig()
          })
      },
      btnApplyEnabled: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/disable-app'
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['disabled'] = vm.convertFieldToBoolean(vm.disabledApp)
        config['disabledMessage'] = 'This app is currently disabled. Please contact support@mezzanineware.com for further assistance.'
        config['username'] = vm.$parent.username
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' })
            vm.getCurrentConfig()
            vm.undoKey = null
            vm.undoValue = null
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' })
            vm.getCurrentConfig()
          })
      },
      btnApplyLocked: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/lock-app'
        let config = {}
        config['baseUrl'] = vm.$parent.environment.baseUrl
        config['appId'] = vm.app.id
        config['locked'] = vm.convertFieldToBoolean(vm.lockedApp)
        config['lockedMessage'] = 'This app is currently locked. Please contact support@mezzanineware.com for further assistance.'
        config['username'] = vm.$parent.username
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' })
            vm.getCurrentConfig()
            vm.undoKey = null
            vm.undoValue = null
          })
          .catch(function (error) {
            console.log(error)
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' })
            vm.getCurrentConfig()
          })
      },
      convertFieldToBoolean (value) {
        if (value === 'Disabled' || value === 'Locked') {
          return true
        } else if (value === 'Enabled' || value === 'Unlocked') {
          return false
        }
      },
      convertBooleanToFieldDisabled (value) {
        if (value === true) {
          return 'Disabled'
        } else {
          return 'Enabled'
        }
      },
      convertBooleanToFieldLocked (value) {
        if (value === true) {
          return 'Locked'
        } else {
          return 'Unlocked'
        }
      }
    },
    created () {
      let vm = this
      vm.$parent.apps.forEach(function (key) {
        if (key.id === vm.$route.params.appid) {
          vm.app = key
        }
      })
      vm.getCurrentConfig()
      vm.getTeams()
      vm.configUndo = vm.config
    },
    watch: {
      'entryPointType': function (val) {
        this.updateModalValues(val, this.entryPointScope, this.entryPointName, this.entryPointValue)
      }
    },
    computed: {
      timeoutValueClass: function () {
        return {
          'text-primary': this.entryPointValue === 0,
          'text-success': this.entryPointValue < 20,
          'text-warning': this.entryPointValue >= 20,
          'text-danger': this.entryPointValue > 45
        }
      },
      maxDatabaseResultsValueClass: function () {
        return {
          'text-primary': this.maxDatabaseResults === 0,
          'text-success': this.maxDatabaseResults < 2500,
          'text-warning': this.maxDatabaseResults >= 2500,
          'text-danger': this.maxDatabaseResults > 6000
        }
      },
      timeoutValues: function () {
        let values = []
        for (var i = 1; i <= 120; i = i + 5) {
          if (i === 6) {
            i--
          }
          values.push(i)
        }
        return values
      },
      maxDatabaseResultsValues: function () {
        let values = []
        for (var i = 1; i <= 100000; i = i + 500) {
          if (i === 501) {
            i--
          }
          values.push(i)
        }
        return values
      }
    },
    mounted () {
      let vm = this
      window.addEventListener('keydown', (e) => {
        if (vm.modalShow && e.keyCode === 27) {
          vm.modalCloseCallback()
        }
      })
    }
  }
</script>

<style scoped>
  #timeouts-info {
    margin: 10px;
    max-width: 100%;
  }
  form {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// Config.vue?27991a6c